import type { IconSvgObject } from './types';

const WaveSquareIcon: IconSvgObject = [
  ["path", { d: "M3 12H8V5H12V19L15.9996 19L15.9996 12H20.9996", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default WaveSquareIcon;
